import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { Spinner } from "../components/common/Spinner";

export interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireUser?: boolean; // NEW: for user-only routes
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = false,
  requireUser = false,
}) => {
  const location = useLocation();
  const { isAuthenticated, user, loading, initialCheckDone } = useSelector(
    (state: RootState) => state.auth
  );

  // Show loading spinner while checking auth
  if (loading || !initialCheckDone) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900">
        <Spinner size="lg" />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Admin trying to access user-only routes -> redirect to admin dashboard
  if (requireUser && user?.role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  // User trying to access admin routes -> redirect to user dashboard
  if (requireAdmin && user?.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
